import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
import {formatDate, formatPrice} from "../utils/helpers";

const SingleBooking = () => {
    const [park, setPark] = useState({});
    const [caravanPrice, setCaravanPrice] = useState(null);
    const [cottagePrice, setCottagePrice] = useState(null);

    // eslint-disable-next-line no-undef
    let { bookingParkId, language, translations, urls, themeUrl, cottages, maintenance, apiBaseUrl } = pluginGlobals;
    const parksApiBase = `${apiBaseUrl || 'https://api.bestpark.fi'}/parks`;
    // #region agent log
    fetch('http://localhost:7710/ingest/9db838d3-4f8b-4779-a962-9767ddff3b5d',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'ba29f5'},body:JSON.stringify({sessionId:'ba29f5',runId:'pre-fix',hypothesisId:'H1-H5',location:'SingleBooking.js:init',message:'booking widget URLs',data:{parksApiBase,bookingUrl:urls&&urls.booking,cottageBookingUrl:urls&&urls.cottageBooking,maintenanceBookingUrl:urls&&urls.maintenanceBooking},timestamp:Date.now()})}).catch(()=>{});
    // #endregion

    // eslint-disable-next-line no-undef
    if (!bookingParkId && bookingPageSelectedPark && bookingPageSelectedPark > 0) {
        // eslint-disable-next-line no-undef
        bookingParkId = bookingPageSelectedPark;
    }

    let cottageCat = false;
    // eslint-disable-next-line no-undef
    if ((cottages && !cottages.categoryId) && typeof bookingPageCottageCategory !== 'undefined' && bookingPageCottageCategory > 0) {
        // eslint-disable-next-line no-undef
        cottageCat = bookingPageCottageCategory;
    }

    let maintenanceAvailable = true;
    // eslint-disable-next-line no-undef
    if (typeof maintenance !== 'undefined' && maintenance && maintenance.status) {
        // eslint-disable-next-line no-undef
        maintenanceAvailable = maintenance.status === 'available';
    }

    // eslint-disable-next-line no-undef
    if (typeof bookingPageMaintenanceAvailable !== 'undefined' && bookingPageMaintenanceAvailable && bookingPageMaintenanceAvailable != '') {
        // eslint-disable-next-line no-undef
        maintenanceAvailable = bookingPageMaintenanceAvailable === 'available';
    }

    const today = new Date();
    const endDate = new Date().setDate(today.getDate()+30);

    useEffect(() => {
        if (!bookingParkId || !language) return;

        axios.get(`${parksApiBase}/${bookingParkId}?data=services`)
            .then((response) => {
                setPark(response.data);
            });

        axios.get(`${parksApiBase}/${bookingParkId}/prices?startDate=${formatDate(today)}&endDate=${formatDate(endDate)}`)
            .then((response) => {
                const dates = Object.values(response.data.result);
                const prices = dates.map(date => {
                    return date.price;
                });
                const min = Math.min.apply(null, prices);
                setCaravanPrice(min);
            });

    },[bookingParkId, language]);

    useEffect(() => {
        console.log(cottageCat);
        // eslint-disable-next-line no-undef
        if (((cottages && cottages.categoryId) || cottageCat) && bookingParkId) {
            // eslint-disable-next-line no-undef
            const catID = typeof bookingPageCottageCategory !== 'undefined' ? bookingPageCottageCategory : cottages.categoryId;
            axios.get(`${parksApiBase}/${bookingParkId}/prices?startDate=${formatDate(today)}&endDate=${formatDate(endDate)}&category=${catID}`)
                .then((response) => {
                    const dates = Object.values(response.data.result);
                    const prices = dates.map(date => {
                        return date.price;
                    });
                    const min = Math.min.apply(null, prices);
                    setCottagePrice(min);
                });
        }
        // eslint-disable-next-line no-undef
    }, [bookingParkId, cottages, cottageCat]);

    const services = park ? park.availableServices : {};

    return (
        <>
            <h2>{translations.bookTitleText}</h2>
            <a href={`${urls.booking}/${bookingParkId}` }>
                <span>
                    <img src={`${themeUrl}/img/parks/caravan.svg`} alt="" />
                </span>
                <span style={{ paddingTop: !services || !services.maintenance ? '11px' : '', display: !services || !services.maintenance ? 'inline-block' : '' }}>{translations.bookCtaText}</span>
                {caravanPrice ? (
                    <><br />{translations.fromText} {formatPrice(caravanPrice)}</>
                ) : null}
            </a>
            {maintenanceAvailable && (
                <a href={`${urls.maintenanceBooking}/${bookingParkId}` }>
                    <span>
                        <img src={`${themeUrl}/img/parks/maintenance.svg`} alt=""  style={ { width: '22px' } } />
                    </span>
                    <span style={{ paddingTop: !services || !services.maintenance ? '11px' : '', display: !services || !services.maintenance ? 'inline-block' : '' }}>{translations.bookMaintenanceCtaText}</span>
                    {park && park.serviceEntryPrice ? (
                        <><br />{translations.fromText} {formatPrice(park.serviceEntryPrice)}</>
                    ) : null}
                </a>
            )}
            {cottagePrice &&  (
                <a href={`${urls.cottageBooking}/${bookingParkId}/${cottageCat ? cottageCat : cottages.categoryId}` }>
                    <span>
                        <img src={`${themeUrl}/img/parks/cottage.svg`} alt="" />
                    </span>
                    <span>{translations.bookCottageCtaText}</span><br />
                    {translations.fromText} {formatPrice(cottagePrice)}
                </a>
            )}
        </>);
};
export default SingleBooking;
